import React from "react";
import { Sofa, Package, Wand2, LucideIcon } from "lucide-react";
import { useImageStudio } from "../../context/ImageStudioContext";

// Map the backend icon name → a lucide icon (fallback to Wand2).
const ICONS: Record<string, LucideIcon> = { Sofa, Package, Wand2 };

const PresetGallery: React.FC = () => {
  const { presets, presetsLoading, selectPreset, referencePreviewUrl } = useImageStudio();

  return (
    <div className="space-y-3">
      <div>
        <h2 className="text-sm font-semibold text-primary">Presets</h2>
        <p className="mt-0.5 text-[11px] leading-snug text-subtle">
          Guided workflows for common tasks. Or use the tabs above for full control.
        </p>
      </div>

      {referencePreviewUrl && (
        <div className="flex items-center gap-2.5 rounded-md border border-border-default bg-surface-2 p-2">
          <img
            src={referencePreviewUrl}
            alt="loaded input"
            className="h-10 w-10 shrink-0 rounded object-cover"
          />
          <p className="text-[11px] leading-snug text-subtle">
            Your image is loaded — pick a preset to use it.
          </p>
        </div>
      )}

      {presetsLoading && presets.length === 0 ? (
        <p className="text-xs text-subtle">Loading…</p>
      ) : (
        <div className="space-y-2">
          {presets.map((p) => {
            const Icon = (p.icon && ICONS[p.icon]) || Wand2;
            return (
              <button
                key={p.key}
                type="button"
                onClick={() => selectPreset(p.key)}
                className="flex w-full items-start gap-3 rounded-lg border border-border-default bg-surface-2 px-3 py-3 text-left transition-colors hover:border-violet-500 hover:bg-surface-3"
              >
                <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-surface-brand text-violet-500">
                  <Icon size={18} />
                </span>
                <span className="min-w-0">
                  <span className="block text-sm font-medium text-primary">{p.label}</span>
                  <span className="mt-0.5 block text-[11px] leading-snug text-subtle">
                    {p.description}
                  </span>
                </span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default PresetGallery;
